import { createSlice } from "@reduxjs/toolkit";
import Swal from 'sweetalert2';
import { getVoucher, submitVoucher, deleteVoucher } from "./Utils/voucherUtils";

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
        "include": "",
    },
    vouchers: [],
    pagination: {},
    loading: false,
    error: null,
    currentVoucher: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        code: "",
        discount: "",
        quota: "",
        type: "", // 1: percentage, 2: nominal
        expired_at: "",
        is_public: null,
        banner: null,
    }
};

const voucherSlice = createSlice({
    name: "voucher",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentVoucher = { ...state.currentVoucher, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentVoucher = initialState.currentVoucher;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getVoucher
            .addCase(getVoucher.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVoucher.fulfilled, (state, action) => {
                state.loading = false;
                state.vouchers = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getVoucher.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle submitVoucher (update atau tambah branch)
            .addCase(submitVoucher.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitVoucher.fulfilled, (state, action) => {
                state.loading = false;
                state.vouchers = state.vouchers.map(voucher => {
                    if (voucher.id === action.payload.id) {
                        return action.payload;
                    }
                    return voucher;
                });
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Voucher has been saved',
                    showConfirmButton: false,
                    timer: 1500
                });
            })
            .addCase(submitVoucher.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: 'Voucher failed to save',
                    showConfirmButton: false,
                    timer: 1500
                });
            })

            // Handle deleteVoucher
            .addCase(deleteVoucher.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteVoucher.fulfilled, (state, action) => {
                state.loading = false;
                state.vouchers =
                    state.vouchers.filter(voucher => voucher.id !== action.payload.id);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Voucher has been deleted',
                    showConfirmButton: false,
                    timer: 1500
                });
            });
    }
});

export const { setFormData, resetFormData, setFilters } = voucherSlice.actions;

export default voucherSlice.reducer;
